import { forwardRef } from 'react';
import type { PolymorphicComponentPropWithRef, PolymorphicRef } from '../types';
import styles from './screen-reader-only.module.css';
import clsx from 'clsx';

export type ScreenReaderOnlyProps<As extends React.ElementType = 'div'> =
  PolymorphicComponentPropWithRef<As>;

type ScreenReaderOnlyComponent = <As extends React.ElementType = 'div'>(
  props: ScreenReaderOnlyProps<As>
) => JSX.Element;

export const ScreenReaderOnly: ScreenReaderOnlyComponent = forwardRef(
  function ScreenReaderOnlyProps<As extends React.ElementType = 'div'>(
    { as, className, ...rest }: ScreenReaderOnlyProps<As>,
    ref?: PolymorphicRef<As>
  ) {
    const Tag = as || 'div';
    const classes = clsx(styles.srOnly, className);

    return <Tag className={classes} ref={ref} {...rest} />;
  }
) as ScreenReaderOnlyComponent;
